import React from 'react';
import { Input, Icon, Form } from 'semantic-ui-react';
import { postcodeLocator } from '../../helpers/mapFunctions';
import Datatable from '../Datatable';

class FormsPostcodeSearch extends React.Component {
  state = {
    result: [],
  };

  postcodeSearch = async (event) => {
    const response = await postcodeLocator(event.target.value);
    this.setState({ result: response });
  };

  render() {
    const { result } = this.state;

    const tableData = {
      headers: ['Postcode', 'Suburb', 'Network Distributor'],
      rows: result.map((res) => {
        return [res.postcode, res.suburb, res.distributor];
      }),
    };
    return (
      <Form>
        <h4>Find your network</h4>
        <p style={{ marginBottom: 0 }}>
          Enter your postcode to find out which network you belong to.
        </p>
        <Input
          onChange={this.postcodeSearch.bind(this)}
          className="postcode-search__input forms"
          placeholder="Enter postcode"
          aria-label="Enter postcode"
          icon={<Icon name="search" color="red" size="large" />}
        />
        {result && result.length > 0 && (
          <Datatable
            header={tableData.headers}
            rows={[tableData.rows]}
            displayMobileHeaders={true}
          />
        )}
      </Form>
    );
  }
}

export default FormsPostcodeSearch;
